
const MASTER_DATA = "master"
const ORGANIZATION = "organization-structure"
const USER_MANAGEMENT = "user-management"
const WBS_INIT = "wbs-init"
// const WBS_TASK_SUBMISSION = "task-submission"
// const WBS_TASK_APPROVAL = "task-approval"
const WBS = "wbs"
const TASK = "task"
const RESOURCE = "resource"
const REPORT = "report"

// const queryStringListTab = `?${Constant.ConstantParamTab}=${Constant.ConstantQueryStringTab.list}`
//const queryStringPendingTaskTab = `?${Constant.ConstantParamTab}=${Constant.ConstantQueryStringTab.pendingTask}`

export const APP_ROUTE_PREFIX = '/app'
export const RouteConstant = {
    login: "/",
    tenantSelection: "tenant-selection",
    dashboard: "dashboard",
    workspaceSetup: "workspace-setup",
    myProfile: "my-profile",
    resetPassword: "/reset-password/user",
    forgotPassword: "/forgot-password",
    userManagement: {
        role: {
            index: `${USER_MANAGEMENT}/role/list`,
            create: `${USER_MANAGEMENT}/role/create`,
            edit: (roleId) => `${USER_MANAGEMENT}/role/${roleId}`,
        },
        user: {
            index: `${USER_MANAGEMENT}/user/list`,
            create: `${USER_MANAGEMENT}/user/create`,
            edit: (userId) => `${USER_MANAGEMENT}/user/${userId}`,
        },
    },
    organization: {
        chart: `${ORGANIZATION}/chart`,
        org: {
            index: `${ORGANIZATION}/organization/list`,
            create: `${ORGANIZATION}/organization/create`,
            edit: (orgId) => `${ORGANIZATION}/organization/${orgId}`,
        },
        department: {
            index: `${ORGANIZATION}/department/list`,
            create: `${ORGANIZATION}/department/create`,
            edit: (deptId) => `${ORGANIZATION}/department/${deptId}`,
        },
        division: {
            index: `${ORGANIZATION}/division/list`,
            create: `${ORGANIZATION}/division/create`,
            edit: (divId) => `${ORGANIZATION}/division/${divId}`,
        },
        position: {
            index: `${ORGANIZATION}/position/list`,
            create: `${ORGANIZATION}/position/create`,
            edit: (posId) => `${ORGANIZATION}/position/${posId}`,
        }
    },
    masterData: {
        WorkingCalendar: {
            index: `${MASTER_DATA}/WorkingCalendar/list`,
            create: `${MASTER_DATA}/WorkingCalendar/create`,
            edit: (wcId) => `${MASTER_DATA}/WorkingCalendar/${wcId}`,
        },

    },
    workBreakdownStructure: {
        index: `${WBS_INIT}/list`,
        create: `${WBS_INIT}/create`,
        edit: (wbsId) => `${WBS_INIT}/edit/${wbsId}`,

        submission: {
            view: (taskId) => `${WBS}/task-submission/${taskId}`,
        },

        review: {
            view: (taskId) => `${WBS}/task-review/${taskId}`,
        },
        approval: {
            view: (taskId) => `${WBS}/task-approval/${taskId}`,
        }
    },
    task: {
        index: `${TASK}/list`,
        edit: (taskId) => `${TASK}/${taskId}`,
    },
    resource: {
        index: `${RESOURCE}/resource`,
    },

    report: {
        reportOrganization: `${REPORT}/organization`,
        reportDivision: (orgId) => `${REPORT}/division/${orgId}`,
        //reportDivision: `${REPORT}/division/:orgId`,
        // reportDepartment: (divId) => `${REPORT}/department/${divId}`,
        reportDepartment: (orgId, divId) => `report/department/${orgId}/${divId}`,
        // reportDepartment: `${REPORT}/department`,
        reportPosition: (orgId, divId,deptId) => `${REPORT}/position/${orgId}/${divId}/${deptId}`,
        // reportPosition: `${REPORT}/position`,
        reportWbs: `${REPORT}/wbs`,
        reportWbsDetail: (wbsId) => `${REPORT}/wbs-detail/${wbsId}`,

    },
}
